export default __webpack_public_path__ + "static/media/course availability.da9abdff.jpg";